import { useCreatePresetMutationApi } from '@aibees/shared/api';
import { presetNameCharLimit } from '@aibees/shared/constants';
import { ParsedPreset, PresetVisibility } from '@aibees/shared/definition';
import { useNotify } from '@aibees/shared/hooks';
import { useTableLayoutTemplateContext } from '../context';

export function useCloneTemplateItem() {
  const notify = useNotify();
  const { setId, setNewlyCreatedId } = useTableLayoutTemplateContext();

  const { mutateAsync } = useCreatePresetMutationApi(true);

  const handleClone = (item: ParsedPreset<any>) => {
    if (!item) {
      return;
    }

    const name = `${item.name}-copy`;
    if (name.length > presetNameCharLimit) {
      notify.error(
        `Template name should be less than ${presetNameCharLimit} characters`
      );
      return;
    }
    const value = item.value.default
      ? 'items' in item.value
        ? item.value.items
        : {
            ...item.value,
            default: false,
          }
      : item.value;

    const cloneValue = {
      name,
      type: item.type,
      value: value,
      visibility: item.visibility,
    } as {
      name: string;
      type: string;
      value: any;
      visibility: PresetVisibility;
    };

    mutateAsync(cloneValue)
      .then((response) => {
        setNewlyCreatedId(response.id);
        notify.success(`Template cloned successfully`);
      })
      .catch((err) => notify.error(err));
  };

  return { handleClone };
}
